import Typography from '@/features/ui/typography'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'

const Header: FC = () => {
    const { t } = useTranslation()

    return (
        <Typography.Description font="medium" style={{ marginBottom: 12 }}>
            {t('pos.suggestedProducts')}
        </Typography.Description>
    )
}

export default Header
